var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaxStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F3F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.636 15L4.26 10.52H4.228C4.23333 10.6267 4.24133 10.7867 4.252 11C4.26267 11.2133 4.27333 11.4427 4.284 11.688C4.29467 11.928 4.3 12.1467 4.3 12.344V15H3.22V9.288H4.868L6.22 13.656H6.244L7.676 9.288H9.324V15H8.196V12.296C8.196 12.1147 8.19867 11.9067 8.204 11.672C8.21467 11.4373 8.22267 11.216 8.228 11.008C8.23867 10.7947 8.24667 10.6347 8.252 10.528H8.22L6.748 15H5.636ZM14.2629 15L13.8469 13.64H11.7669L11.3509 15H10.0469L12.0629 9.264H13.5429L15.5669 15H14.2629ZM13.1429 11.296C13.1162 11.2053 13.0815 11.0907 13.0389 10.952C12.9962 10.8133 12.9535 10.672 12.9109 10.528C12.8682 10.384 12.8335 10.2587 12.8069 10.152C12.7802 10.2587 12.7429 10.392 12.6949 10.552C12.6522 10.7067 12.6095 10.856 12.5669 11C12.5295 11.1387 12.5002 11.2373 12.4789 11.296L12.0709 12.624H13.5589L13.1429 11.296ZM20.9063 15H19.5223L18.1943 12.84L16.8663 15H15.5703L17.4663 12.056L15.6903 9.288H17.0263L18.2583 11.344L19.4663 9.288H20.7703L18.9783 12.12L20.9063 15Z",
    fill: "#4D5975"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxStep);
export default __webpack_public_path__ + "static/media/MaxStep.0dde78f9e83d200de03aece13ab1d2e7.svg";
export { ForwardRef as ReactComponent };